export default ({ COLORS }) => ({
  bone: {
    height: '40px !important',
    borderRadius: '4px !important',
    width: '100% !important'
  },
  fetchingError: {
    height: '40px',
    borderRadius: '4px',
    color: COLORS.RED.NORMAL,
    backgroundColor: '#FEF7F6',
    border: `1px solid ${COLORS.RED.NORMAL}`,
    padding: '10px 15px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
})
